import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { scaleIn400ms } from '../../../@vex/animations/scale-in.animation';
import { fadeInRight400ms } from '../../../@vex/animations/fade-in-right.animation';
import { ApiService } from '../../services/api.service';
import { Customer } from '../../entities/customer.entity';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { NewCustomerDialogComponent } from './dialogs/new-customer-dialog.component';
import { EditCustomerDialogComponent } from '@app/pages/customer/dialogs/edit-customer-dialog.component';
import { Subscription } from 'rxjs';
import { SpinnerService } from '@components/spinner/spinner.service';
import { AppMessageService } from '@services/message.service';
import { ConfirmPopup } from '@components/dialogs/confirm-popup/confirm-popup.component';

@Component({
	selector: 'app-customer',
	template: `
		<div class="py-gutter container">
			<h1 class="standard-headline">{{ 'MAINMENU.CUSTOMERS' | translate }}</h1>
			<br />
			<div class="flex flex-col">
				<div style="min-width: 100%; margin: 10px; margin-left:0px">
					<div class="flex-auto">
						<div class="flex">
							<div class="flex-1"></div>
							<div
								class="mat-raised-button relative flex items-center cursor-pointer select-none rounded-full px-4 py-2 hover:bg-green-light trans-ease-out"
								matRipple
								(click)="addNewCustomer()"
							>
								<div @scaleIn class="p-2 bg-green-light rounded-full ltr:mr-4 rtl:ml-4">
									<mat-icon style='display: block;'>add</mat-icon>
								</div>
								<p @fadeInRight class="font-medium">New Customer</p>
							</div>
							<div class="flex-1"></div>
						</div>
					</div>
				</div>

				<!-- @stagger  -->
				<table mat-table matSort #sort1 [dataSource]="customerDataSource" [trackBy]="myTrackById"
					   class="w-full mat-elevation-z1">
					<ng-container matColumnDef="logo">
						<th mat-header-cell mat-sort-header [ngClass]="'w-12'" *matHeaderCellDef></th>
						<td mat-cell *matCellDef="let element">
							<img *ngIf="element.dbFile" [src]="element?.dbFile.content"/>
						</td>
					</ng-container>
					<ng-container matColumnDef="name">
						<th mat-header-cell mat-sort-header [ngClass]="'w-full'" *matHeaderCellDef>Name</th>
						<td mat-cell *matCellDef="let element">
							<span>{{ element.name }}</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="action">
						<th mat-header-cell mat-sort-header [ngClass]="'w-8'" *matHeaderCellDef>Action</th>
						<td mat-cell *matCellDef="let element">
							<button mat-icon-button type="button" (click)="changeCustomer(element)">
								<mat-icon style="margin-top: -3px; font-size: 18px;">edit</mat-icon>
							</button>
							<button mat-icon-button type="button" (click)="deleteCustomer(element)">
								<mat-icon style="margin-top: -3px; font-size: 18px;">delete</mat-icon>
							</button>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="columns"></tr>
					<tr mat-row *matRowDef="let row; columns: columns"></tr>
					<!-- @fadeInUp  -->
				</table>
				<mat-paginator #paginator1 [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"></mat-paginator>
			</div>
		</div>
	`,
	animations: [scaleIn400ms, fadeInRight400ms],
	styleUrls: ['customer.component.scss'],
})
export class CustomerComponent implements OnInit, OnDestroy {
	private subscriptions: Subscription[] = [];
	customers: Customer[];
	pageSize = 10;
	pageSizeOptions: number[] = [5, 10, 20, 50];
	@ViewChild(MatPaginator) paginator1: MatPaginator;
	@ViewChild(MatSort) sort1: MatSort;
	customerDataSource = new MatTableDataSource<Customer>(null);
	columns: string[] = ['logo', 'name', 'action'];

	constructor(
		private dialog: MatDialog,
		private apiService: ApiService,
		private spinner: SpinnerService,
		private appMessageService: AppMessageService
	) {
	}

	async ngOnInit() {
		this.customers = await this.apiService.get('customers');
		this.customerDataSource.data = this.customers;
	}

	myTrackById(index, item) {
		return item.id;
	}

	async addNewCustomer() {
		await this.dialog
			.open(NewCustomerDialogComponent, {
				width: '100%',
				maxWidth: 600,
			})
			.afterClosed()
			.toPromise();
		await this.ngOnInit();
	}

	async changeCustomer(customer) {
		await this.dialog
			.open(EditCustomerDialogComponent, {
				width: '100%',
				maxWidth: 600,
				data: {
					customer,
				},
			})
			.afterClosed()
			.toPromise();
		await this.ngOnInit();
	}

	async deleteCustomer(customer) {
		console.log('Delete Customer', customer);
		await this.dialog
			.open(ConfirmPopup, {
				autoFocus: false,
				panelClass: ['paddingLessPopup'],
				data: {
					title: 'GLOBAL.SURE_TO_DELETE_TITLE',
					lable: 'GLOBAL.SURE_TO_DELETE',
					buttonTextYes: 'BUTTON.DELETE',
					buttonTextNo: 'BUTTON.CANCEL',
				},
			})
			.afterClosed()
			.toPromise()
			.then(result => {
				if (result === true) {
					try {
						this.apiService.delete(`customers/${customer.id}`);
						this.appMessageService.showToastSuccess('Customer deleted');
						this.ngOnInit();
					} catch (e) {
						console.error(e);
						this.appMessageService.showToastError('Can\'t delete customer. Please try again later.');
					}
				}
			});
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(sub => {
			sub.unsubscribe();
		});
	}
}
